import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { USERTYPE } from 'src/app/enum/roles.enum';
import { Client } from 'src/app/model/client.modals';
import { AccessControlService } from 'src/app/services/access-control.service';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import Swal from 'sweetalert2';
import {map} from 'rxjs/operators';

type RequestStatus="Saving.."|"Done";
@Component({
  selector: 'app-client-details',
  templateUrl: './client-details.component.html',
  styleUrls: ['./client-details.component.css']
})
export class ClientDetailsComponent implements OnInit {
  client: Client=new Client();
  clientId: any;
  noData: any;
  dataSource: MatTableDataSource<any>;
  orgId: any;
  isLoading: boolean
  modalRef : BsModalRef;
  requestStatus:RequestStatus="Done";
  displayedColumns: string[] = ['application_name','created_on','Actions'];
  resetModel:{newPassword:string,confirmPassword:string};
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor(private accessControlService: AccessControlService, private router: ActivatedRoute,private modalService: BsModalService,
    private toastrService:ToastrService,private authService:AuthService,private routeModule:Router) {
    this.orgId = localStorage.getItem("org_id");
    this.client.name="";
    this.router.params.subscribe(params => {
      this.clientId = params.id;
    })
  }

  ngOnInit() {
    this.getClientDetails();
  }

  getClientDetails() {
    this.accessControlService.getClient(this.clientId, this.orgId).subscribe((res: any) => {
      if (!res.error)
        this.client = <Client>res.data;
        if(this.client.created_on){
          this.client.created_on=new Date(this.client.created_on);
        }
      this.client.accounttype = res.data.type !== USERTYPE.SUBCLIENT ? "NEW" : "EXISTING";
      // if (this.client.accounttype == "EXISTING")
      //   this.client.email = "";k
      this.client.exisitingUser = res.data.owner || null;
      this.isLoading = false
      this.dataSource = new MatTableDataSource<any>(this.client.applications);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

    }, error => {
      this.isLoading = false
    })
  }
  applyFilter(event: Event) {
    this.noData = this.dataSource.connect().pipe(map(data => data.length === 0));
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

}
